import { useCallback } from 'react';
import { useParams } from 'react-router';
import { useFlags } from '@repo/poly-hooks/flags';
import { useQuery } from '@tanstack/react-query';
import { usersQueries } from '@repo/shared-kit/api/current-user';
import { KycRouter } from '@repo/due-diligence-kit/kyc';
import { useSuspenseRegistration } from 'register-partners-js/react/hooks/use-registration';
import { useSubmitRegistration } from 'register-partners-js/react/hooks/use-submit-registration';
import { KycLoading } from './loading';

export function KycRoute() {
  const { registration_id: registrationId } = useParams<{
    registration_id: string;
  }>();
  const {
    data: { organization, owner },
  } = useSuspenseRegistration(registrationId);
  const { scalingAsyncContractSignature } = useFlags();
  const { data: currentUserData } = useQuery(usersQueries.getMe());

  const { submit, submitAsync, isSubmitting, isContractSignPending } = useSubmitRegistration({
    registrationId: registrationId ?? '',
    organizationId: organization.id,
  });

  const handleComplete = useCallback(async () => {
    if (scalingAsyncContractSignature) {
      await submitAsync();
    } else {
      await submit();
    }
  }, [scalingAsyncContractSignature, submit, submitAsync]);

  if (!organization.legalCountry) {
    return null;
  }

  if (isSubmitting || isContractSignPending) {
    return <KycLoading />;
  }

  return (
    <KycRouter
      hasGermanResidencePermit={false}
      isRegisterFlow
      legalCountry={organization.legalCountry}
      membershipId={owner?.id}
      onComplete={handleComplete}
      trackingPrefix="onboarding_partner"
      userId={currentUserData?.user?.id}
    />
  );
}
